import React from 'react';
import { Input, Button, TitleModalRight, CheckboxTable, DatePicker } from 'components';
import { DiscountService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Constants, Globals } from 'utils';
import moment from 'moment';
import user from 'reducers/user';

interface Props {
	title?: string;
	onClose?: any;
	item?: any;
	user?: any;
}

class CreateDiscount extends React.Component<Props> {

	state = {
		form: {
			code: '',
			percent: this.props.user?.level_id === Constants.LEVELS.CLIENT ? 10 : '',
			since: this.props.user?.level_id === Constants.LEVELS.CLIENT ? moment().toDate() : '',
			until: this.props.user?.level_id === Constants.LEVELS.CLIENT ? moment().add(1, 'year').toDate() : '',
			quantity: this.props.user?.level_id === Constants.LEVELS.CLIENT ? 10000 : '',
			user_id: this.props.user?.id || null,
		}
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					code: this.props.item?.code || '',
					quantity: this.props.item?.quantity || '',
					since: this.props.item?.since ? moment(this.props.item?.since).toDate() : '',
					until: this.props.item?.until ? moment(this.props.item?.until).toDate() : '',
					percent: this.props.item?.percent || '',
				},
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		const isClient = this.props.user?.level_id === Constants.LEVELS.CLIENT;
		if (isClient) {
			const code = (this.state.form.code || '').trim(); // Sanitizamos espacios accidentales

			// VALIDACIÓN 1: Integridad Alfanumérica
			// Regex: ^ (inicio) [a-z0-9] (rango permitido) + (uno o más) $ (fin)
			// La bandera 'i' hace que no importe mayúsculas/minúsculas
			const isStrictlyAlphanumeric = /^[a-z0-9]+$/i.test(code);

			if (!isStrictlyAlphanumeric) {
				// Aquí disparas tu alerta de UI (ej. Swal, Toast, State error)
				Globals.showError("El código contiene caracteres inválidos. Solo se permiten letras y números.");
				return;
			}

			// VALIDACIÓN 2: Regla de Mezcla (Letras Y Números)
			// Verificamos la existencia de ambos tipos
			const hasLetter = /[a-z]/i.test(code);
			const hasNumber = /[0-9]/.test(code);

			if (!hasLetter || !hasNumber) {
				Globals.showError("El código debe ser alfanumérico (debe contener al menos una letra y un número).");
				return;
			}
		}
		
		if (this.props.item != null) {
			await DiscountService.admin.update({
				discount_id: this.props.item?.id,
				...this.state.form,
			});
			Globals.showSuccess("Se ha modificado el descuento correctamente");
			this.props.onClose();
		}
		else {
			await DiscountService.admin.create({
				...this.state.form,
			});
			Globals.showSuccess("Se ha creado el descuento correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		const { user } = this.props;
		const { form } = this.state;

		const isClient = user?.level_id === Constants.LEVELS.CLIENT;

		return (
			<div id="create-discount">
				<TitleModalRight
					title={ this.props.title }
					onClose={ this.props.onClose }
				/>
				<form className="container-scroll-modal-right" onSubmit={ this.submit }>
					<div className="col-md-12">
						<Input
							color="white"
							value={ this.state.form.code }
							name="code" 
							className="input-code"
							placeholder="Código"
							onChange={ this.change } 
							maxLength={isClient ? 8 : undefined}
						/>
					</div>
					{!isClient && (
						<div className="col-md-12">
							<DatePicker
								placeholder="Desde"
								minDate={moment().toDate()}
								maxDate={this.state.form.until ? moment(this.state.form.until).toDate() : null}
								onChange={(text: string) => {
									this.change({
										target: {
											value: text,
											name: 'since'
										}
									});
								}}
								value={this.state.form.since}
							/>
						</div>
					)}
					{!isClient && (
						<div className="col-md-12">
							<DatePicker
								placeholder="Hasta"
								minDate={ this.state.form.since ? moment(this.state.form.since).toDate() : moment().toDate() }
								onChange={ (text: string) => {
									this.change({
										target: {
											value: text,
											name: 'until'
										}
									});
								} }
								value={ this.state.form.until }
							/>
						</div>
					)}
					{!isClient && (
						<div className="col-md-12">
							<Input
								color="white"
								type="percentage"
								value={this.state.form.percent}
								name="percent"
								placeholder="Porcentaje"
								onChange={this.change}
							/>
						</div>
					)}
					{!isClient && (
						<div className="col-md-12">
							<Input
								type="number"
								color="white"
								value={this.state.form.quantity}
								name="quantity"
								placeholder="Máximo de veces"
								onChange={this.change} />
						</div>
					)}
					<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default CreateDiscount;